var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedesSociais(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 40,
    viewBox: "0 0 296 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(-807 -719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(293 73.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    transform: "translate(514 645.621)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M25.228,6.8a9.878,9.878,0,0,1-2.806.772,4.9,4.9,0,0,0,2.15-2.7,9.708,9.708,0,0,1-3.1,1.186A4.884,4.884,0,0,0,13.015,9.39a4.783,4.783,0,0,0,.126,1.115A13.846,13.846,0,0,1,3.069,5.393a4.9,4.9,0,0,0,1.519,6.53,4.772,4.772,0,0,1-2.22-.611v.061a4.89,4.89,0,0,0,3.921,4.794A4.918,4.918,0,0,1,5,16.339a4.609,4.609,0,0,1-.918-.091,4.894,4.894,0,0,0,4.567,3.4,9.8,9.8,0,0,1-6.071,2.094,9.9,9.9,0,0,1-1.166-.071,13.657,13.657,0,0,0,7.479,2.21A13.819,13.819,0,0,0,22.806,9.96c0-.212-.005-.424-.015-.631A9.946,9.946,0,0,0,25.228,6.8Z",
    transform: "translate(520.587 651.121)",
    fill: "#1da1f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(260 73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    transform: "translate(595 646)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M13.018,12.822,13.651,8.7H9.693V6.02a2.063,2.063,0,0,1,2.326-2.229h1.8V.279A21.946,21.946,0,0,0,10.624,0C7.364,0,5.233,1.976,5.233,5.553V8.7H1.609v4.125H5.233V22.8h4.46V12.822Z",
    transform: "translate(607.286 654.602)",
    fill: "#4267b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(233 73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    transform: "translate(674 646)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.077,18.212H.3V6.053H4.077ZM2.187,4.395A2.2,2.2,0,1,1,4.373,2.187,2.205,2.205,0,0,1,2.187,4.395ZM18.208,18.212H14.44V12.293c0-1.411-.028-3.22-1.963-3.22-1.963,0-2.264,1.533-2.264,3.118v6.021H6.442V6.053h3.621V7.712h.053a3.967,3.967,0,0,1,3.572-1.963c3.821,0,4.524,2.516,4.524,5.785v6.679Z",
    transform: "translate(684.894 656.893)",
    fill: "#2867b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(215 73.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    transform: "translate(744 645.621)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M25.367,7.232a3.121,3.121,0,0,0-2.2-2.21c-1.937-.522-9.7-.522-9.7-.522s-7.766,0-9.7.522a3.121,3.121,0,0,0-2.2,2.21,32.737,32.737,0,0,0-.519,6.017,32.737,32.737,0,0,0,.519,6.017,3.074,3.074,0,0,0,2.2,2.175c1.937.522,9.7.522,9.7.522s7.766,0,9.7-.522a3.074,3.074,0,0,0,2.2-2.175,32.737,32.737,0,0,0,.519-6.017,32.737,32.737,0,0,0-.519-6.017ZM10.928,16.942V9.556l6.491,3.693-6.491,3.693Z",
    transform: "translate(750.95 652.121)",
    fill: "#fd1c50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(211 72.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    transform: "translate(800 646.621)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1,
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(809.003 655.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M21.563,7.081a7.483,7.483,0,0,0-.48-2.539,5.282,5.282,0,0,0-3.017-3.017,7.569,7.569,0,0,0-2.5-.481C14.459.995,14.11.981,11.312.981s-3.157,0-4.251.063a7.569,7.569,0,0,0-2.5.481A5.278,5.278,0,0,0,1.541,4.542a7.509,7.509,0,0,0-.48,2.5C1.012,8.149,1,8.5,1,11.3s0,3.155.064,4.251a7.557,7.557,0,0,0,.48,2.506,5.282,5.282,0,0,0,3.018,3.016,7.546,7.546,0,0,0,2.5.516c1.1.049,1.453.064,4.251.064s3.156,0,4.251-.064a7.554,7.554,0,0,0,2.5-.48,5.288,5.288,0,0,0,3.017-3.017,7.546,7.546,0,0,0,.48-2.506c.049-1.1.064-1.452.064-4.251s0-3.153-.066-4.25ZM11.305,16.587a5.3,5.3,0,1,1,3.745-1.551,5.3,5.3,0,0,1-3.745,1.551Zm5.508-9.554A1.235,1.235,0,1,1,18.047,5.8,1.234,1.234,0,0,1,16.813,7.033Z",
    transform: "translate(0 0)",
    fill: "#4267b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M10.432,13.857a3.441,3.441,0,1,0-3.441-3.441A3.441,3.441,0,0,0,10.432,13.857Z",
    transform: "translate(0.873 0.874)",
    fill: "#4267b2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(195 73.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    transform: "translate(868 645.621)",
    fill: "none",
    stroke: "rgba(220,220,220,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-telegram-plane",
    "data-name": "Icon awesome-telegram-plane",
    d: "M20.709,6.114,17.575,20.893c-.236,1.043-.853,1.3-1.729.811l-4.775-3.519L8.767,20.4a1.2,1.2,0,0,1-.96.468l.343-4.863,8.85-8c.385-.343-.083-.533-.6-.19L5.461,14.709.751,13.234c-1.025-.32-1.043-1.025.213-1.516l18.423-7.1c.853-.32,1.6.19,1.321,1.493Z",
    transform: "translate(877.999 652.093)",
    fill: "#1da1f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedesSociais);
export default __webpack_public_path__ + "static/media/redesSociais.c9e6d670f6668bff58c5b042ca5c66e5.svg";
export { ForwardRef as ReactComponent };